Vue.component('star-rating', require('../../../../legacy/node_modules/vue-star-rating').default);

!function () {
	"use strict";

	var District = function () {}

	District.prototype.initScrollspy = function (e) {
        const navHeight = document.getElementById('topnav').offsetHeight;
		const topNavHeight = navHeight - 30;

		document.querySelectorAll(".scroll_link").forEach(function(element) {
			element.addEventListener('click', function(e) {
				const href = element.getAttribute('href');
				const offsetTop = href === "#" ? 0 : document.querySelector(href).offsetTop - navHeight - topNavHeight + 1;

				e.preventDefault();

				window.scrollTo({
					top: offsetTop,
					behavior: "smooth"
				});
			});
		});
	}

	District.prototype.init = function () {
		this.initScrollspy();
	}

	window.District = new District, window.District.Constructor = District;
}();

window.onload = function () {
    window.District.init();
}
